import { Link } from "wouter";
import { Facebook, Instagram, Utensils, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-neutral-darker text-white relative">
      {/* Premium Divider Line */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        {/* 3-Spalten Layout mit klarer Hierarchie */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16 mb-12">
          {/* Brand Block - Premium */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-primary/90 p-2.5 rounded-xl shadow-lg">
                <Utensils className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-2xl text-white tracking-tight">SpeiseGuru</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-sm">
              Kulinarische Highlights in deiner Nähe. Menüs, Öffnungszeiten und Bewertungen auf einen Blick.
            </p>

            {/* Social Icons - Clean & Premium */}
            <div className="flex items-center gap-3">
              <a 
                href="#" 
                className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-primary/50 flex items-center justify-center transition-colors duration-200 group"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4 text-white/70 group-hover:text-primary transition-colors" />
              </a>
              <a 
                href="#" 
                className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-primary/50 flex items-center justify-center transition-colors duration-200 group"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 text-white/70 group-hover:text-primary transition-colors" />
              </a>
            </div>
          </div>

          {/* Navigation - Strukturiert */}
          <div className="lg:col-span-1">
            <h3 className="text-white font-semibold text-base mb-6 tracking-tight">Navigation</h3>
            <div className="space-y-5">
              <div>
                <h4 className="text-white/90 font-medium mb-3 text-sm uppercase tracking-wider">Seiten</h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link href="/" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Startseite
                    </Link>
                  </li>
                  <li>
                    <Link href="/restaurants" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Restaurants
                    </Link>
                  </li>
                  <li>
                    <Link href="/warum-speiseguru" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Für Restaurants
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="pt-2 border-t border-white/5">
                <h4 className="text-white/90 font-medium mb-3 text-sm uppercase tracking-wider">Küchen</h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link href="/restaurants?cuisines=1" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Italienisch
                    </Link>
                  </li>
                  <li>
                    <Link href="/restaurants?cuisines=2" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Asiatisch
                    </Link>
                  </li>
                  <li>
                    <Link href="/restaurants" className="text-white/60 hover:text-white transition-colors duration-200 text-sm inline-block">
                      Alle Küchen
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Kontakt & Rechtliches - Kompakt */}
          <div className="lg:col-span-1">
            <h3 className="text-white font-semibold text-base mb-6 tracking-tight">Kontakt & Rechtliches</h3>
            <div className="space-y-6">
              <div>
                <h4 className="text-white/90 font-medium mb-3 text-sm uppercase tracking-wider">Kontakt</h4>
                <div className="space-y-2.5 text-sm">
                  <div className="flex items-center gap-2.5 text-white/60">
                    <Mail className="w-3.5 h-3.5 text-primary flex-shrink-0" />
                    <a href="mailto:info@speiseguru.de" className="hover:text-white transition-colors">
                      info@speiseguru.de
                    </a>
                  </div>
                  <div className="flex items-start gap-2.5 text-white/60">
                    <MapPin className="w-3.5 h-3.5 text-primary flex-shrink-0 mt-0.5" />
                    <span>10115 Berlin, Deutschland</span>
                  </div>
                </div>
              </div>

              <div className="pt-2 border-t border-white/5">
                <h4 className="text-white/90 font-medium mb-3 text-sm uppercase tracking-wider">Rechtliches</h4>
                <div className="space-y-2.5">
                  <Link href="/datenschutz" className="block text-white/60 hover:text-white transition-colors duration-200 text-sm">
                    Datenschutz
                  </Link>
                  <Link href="/impressum" className="block text-white/60 hover:text-white transition-colors duration-200 text-sm">
                    Impressum
                  </Link>
                  <Link href="/nutzungsbedingungen" className="block text-white/60 hover:text-white transition-colors duration-200 text-sm">
                    AGB
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright - Minimal & Premium */}
        <div className="border-t border-white/5 pt-8 mt-8">
          <p className="text-white/50 text-xs text-center tracking-wide">
            © {new Date().getFullYear()} SpeiseGuru. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
